import React from "react"
import { Box, Text } from "rebass"
import { SizeMe } from "react-sizeme"
import { motion } from "framer-motion"

import FloatingBox from "./floating-box"
import Cloud from "./cloud"

const YellowCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ bottom: [-40, 100], right: 0 }}
  >
    <motion.div
      animate={{ x: "-100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#FDFF00" />
    </motion.div>
  </Box>
)

const Snippet = () => (
  <SizeMe monitorHeight>
    {size => (
      <Box css={{ position: "relative" }} px={4} py={[4, 6]}>
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{
            x: 0,
            y: 20,
          }}
        />
        <YellowCloud />
        <Box css={{ maxWidth: 900, margin: "0 auto" }}>
          <Text variant="snippet">
            In her mid-twenties, Anna Wiener—stuck, broke, and looking for
            meaning in her work, like any good millennial—left a job in book
            publishing in New York City for the promise of the new digital
            economy in San Francisco. She landed at a big-data startup in the
            heart of Silicon Valley: a world of surreal extravagance, dubious
            success, and fresh-faced entrepreneurs hell-bent on domination,
            glory, and progress. Almost immediately, Anna noticed a new Silicon
            Valley began to emerge: one in far over its head, one that enriched
            itself at the expense of the idyllic future it claimed to be
            building.
          </Text>
          <Text my={4} variant="snippet">
            <em>Uncanny Valley</em>​ is a rare first-person glimpse into
            high-flying, reckless startup culture at a time of unchecked
            ambition, unregulated surveillance, wild fortune, and accelerating
            political power. With wit, candor, and warmth, Anna deftly charts
            the tech industry’s shift from self-appointed world savior to
            democracy-endangering liability, alongside a personal narrative of
            aspiration, ambivalence, and disillusionment.
          </Text>
        </Box>
      </Box>
    )}
  </SizeMe>
)

export default Snippet
